<template>
    <div class="key-top">
        <div class="title">
            <div class="title-content">
                <ul class="title-left">
                    <li class="logo">
                        <a href="http://www.touchsprite.com" target="_blank">
                            <div class="logoimg">
                                <img src="../../assets/images/icon_40.png" alt>
                            </div>
                            <div class="logotext ms-hide">触动精灵</div>
                        </a>
                    </li>
                    <li class="ms-hide" @click="go('search')">授权管理平台</li>
                </ul>
                <ul class="title-right">
                    <li @click="go('search')">查询&解绑</li>
                    <li @click="go('rechange')">授权换绑</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        go(str) {
            this.$store.commit("SET_INFO", {});
            this.$store.commit("SET_RESULT", {});
            this.$router.push(str);
        }
    }
};
</script>

<style lang="less" src="./index.less" scoped></style>


// WEBPACK FOOTER //
// src/common/top/index.vue